import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicBook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMagicBook"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22H4V2ZM18 20V18H6V20H18ZM12.3333 7.33333L13.5 5L14.6667 7.33333L17 8.5L14.6667 9.66667L13.5 12L12.3333 9.66667L10 8.5L12.3333 7.33333ZM9.5 10L8.66667 11.6667L7 12.5L8.66667 13.3333L9.5 15L10.3333 13.3333L12 12.5L10.3333 11.6667L9.5 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicBook;
